<template>
  <div class="homepage">
    <!-- Hero Section -->
    <HeroHome />

    <!-- Anunțuri - Adăugăm spațiu și aliniere corectă -->

     <SiteAnnouncement />

    <!-- Schedule & Price Section -->
    <SchedulePrice />
    <!-- Features Section - Spațiere corectă -->
      <FeaturesHome />


    <!-- About Us Section -->
    <AboutUs />



    <!-- Contact Section -->
    <section id="contact" class="contact py-5" style="background-color: #001F3F; color: #ffffff;">
      <div class="container text-center">
        <h2 class="mb-4 text-uppercase fw-bold text-center">
          <i class="fa fa-phone-alt me-2"></i>{{ $t('contact.title') }}
        </h2>
        <p class="mb-4">{{ $t('contact.description') }}</p>
        <a href="/contact" class="btn btn-light btn-lg">{{ $t('contact.button2') }}</a>
      </div>
    </section>
  </div>
</template>

<script>
import HeroHome from '@/components/HeroHome.vue';
import FeaturesHome from '@/components/FeaturesHome.vue';
import AboutUs from '@/components/AboutUs.vue';
import SchedulePrice from '@/components/SchedulePrice.vue';
import SiteAnnouncement from '@/components/SiteAnnouncement.vue';

export default {
  name: "HomePage",
  components: {
    HeroHome,
    FeaturesHome,
    AboutUs,
    SchedulePrice,
    SiteAnnouncement,
  },
};
</script>
